# require('./style.scss')
angular = require('angular')
pkg = angular.module 'cdms.device.usage', [require('angular-chart.js')]
  .config (ChartJsProvider)->
    options = 
      chartColors: [
        '#46BFBD', '#FDB45C', '#f7464a', '#803690', '#00ADF9', '#949FB1', '#4D5360'
      ]
    ChartJsProvider.setOptions options
    
  .directive "deviceUsage", require('./usage')
  .directive "usageMonitor", require('./monitor')
  .directive "diskUsage", require('./disk')

module.exports = pkg.name




// WEBPACK FOOTER //
// ./src/component/device/usage/index.coffee